import { css } from 'vue-styled-components'

/**
 * Docs: https://material.io/design/layout/responsive-layout-grid.html#breakpoints
 */

const sizes = {
    desktop: {
        min: 1024,
        max: 1280
    },
    wideScreen:{
        min: 1200,
        max: null
    },
    max420: {
        max: 420,
        min: null
    },
    max768: {
        max: 768,
        min: null
    },
    max556: {
        max: 400,
        min: null,
    },
    max1049: {
        max: 1049,
        min: null
    },
    min1000:{
        min: 1000,
        max: null
    },
    min421max768: {
        min: 421,
        max: 768
    },
    min368max768: {
        min: 468,
        max: 768
    },

    min769: {
        min: 768,
        max: null,
    },

    min1240: {
        min: 1240,
        max: null
    },

    min557max733 : {
        min: 557,
        max: 733
    },
    min734max850: {
        min: 734,
        max: 850,
    },
    min851max1049: {
        min: 851,
        max: 1049
    },
    min1050: {
        min: 1050,
        max: null
    },
    min421 : {
        min: 421,
        max: null
    },
};

export default Object.keys(sizes).reduce((acc, label) => {
    let MediaStyle;
    const media = sizes[label];

    acc[label] = (...args) => {
        if( media.min && media.max ) {
            MediaStyle = css`
              @media ($max-width: ${media.max}px ) and ($min-width: ${media.min}px ){
                 ${css(...args)};
              }
       `
        } else if (media.min && !media.max) {
            MediaStyle = css`
              @media (min-width: ${media.min}px ){
                 ${css(...args)};
              }
            `
        } else if (!media.min && media.max) {
            MediaStyle = css`
              @media ($max-width: ${media.max}px ){
                 ${css(...args)};
              }
            `
        }


        return MediaStyle
    };
    return acc
}, {})